import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as S from './styles';
import Provider from './context';
import { Loader } from '../../../components/Loader'
import InformationScreen from "../InformationScreen"
import Widget from './Widget/index'
import { RootState } from 'store/types';
import Preview from './Preview';
import { getGetWidgetsConfig, getGetWidgetsPublish } from './state/actions';
import { getGetWidgetsHtmlCalls } from './state/actions';
import { setSelectedTabConfig } from './state/actions';
import Tabs, { TabItem } from 'components/Tabs';
import { CSSProperties } from 'styled-components';
import { WidgetPageType } from './state/types';

const Reviews = () => {
    const [error, setError] = React.useState<string|undefined> (undefined);
    const [selectedTab, setSelectedTab] = React.useState<WidgetPageType>("individual");
    const { showPreview } = useSelector((rootState: RootState) => {
        return {
            showPreview: rootState.reviews.showPreview,
        }
    }, shallowEqual);

    const dispatch = useDispatch();
    const {
        selectedDealerId,
        widgets,
    } = useSelector((rootState: RootState) => {
        return {
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            widgets: rootState.reviews.widgets,
        }
    }, shallowEqual);

    const tabItems = React.useMemo((): TabItem[] => {
        const style: CSSProperties = {
            fontSize: "14px",
            color: "#122442",
        }
        dispatch(setSelectedTabConfig(selectedTab));
        return [
            {
                displayName: "Edit Individual Widgets",
                internalName: "individual",
                selected: selectedTab === "individual",
                style,
            },
            {
                displayName: "Edit Entire Page",
                internalName: "entire",
                selected: selectedTab === "entire",
                style,
            }
        ];
    }, [selectedTab]);

    React.useEffect(() => {
        if (selectedDealerId) {
            dispatch(getGetWidgetsConfig(selectedDealerId));
            dispatch(getGetWidgetsPublish(selectedDealerId));
            dispatch(getGetWidgetsHtmlCalls(selectedDealerId));
        }
    }, [selectedDealerId]);

    const handleTabSelection = (selectedTab: TabItem) => {        
        setSelectedTab(selectedTab.internalName as WidgetPageType);
    }

    return (
        <S.MainContainer>
          <Provider>
            {error 
            ? <InformationScreen id={error}/>
            : 
                showPreview 
                ?
                <>
                    {
                        widgets &&
                        <Preview selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
                    }
                </>
                : <S.WidgetsContainer selectedTab={selectedTab}>
                    <Tabs
                        tabItems={tabItems}
                        onClickTabItem={handleTabSelection}
                        style={{
                            "height": "30px",
                            "marginTop": "11px",
                            "marginLeft": "0px",
                            "marginRight": "15px",                     
                        }}
                        styleUnderline={{
                            "background": "#122442"
                        }}
                    />
                    {
                        widgets &&
                        <Widget
                            selectedTab={selectedTab}
                            widgetsConfig={selectedTab === "individual" ? widgets.individualConfig : widgets.entireConfig}
                        />
                    }
                </S.WidgetsContainer>
            }
          </Provider>
        </S.MainContainer>
    )
}

export default Reviews;
